const STAFF_LOGIN_VIA_SSO_KEY = "admin:staff-login-via-sso";

export function markStaffLoginViaSso(): void {
  try {
    window.sessionStorage.setItem(STAFF_LOGIN_VIA_SSO_KEY, "1");
  } catch {
    // sessionStorage が利用できない環境では、SSO 判定をスキップする。
  }
}

export function clearStaffLoginViaSso(): void {
  try {
    window.sessionStorage.removeItem(STAFF_LOGIN_VIA_SSO_KEY);
  } catch {
    // sessionStorage が利用できない環境では何もしない。
  }
}

export function isStaffLoginViaSso(): boolean {
  try {
    return window.sessionStorage.getItem(STAFF_LOGIN_VIA_SSO_KEY) === "1";
  } catch {
    return false;
  }
}
